import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { getToken } from '../../utils/auth';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const HorariosAdmin = () => {
  const [horarios, setHorarios] = useState([]);
  const [horariosPorDia, setHorariosPorDia] = useState({});
  const [editando, setEditando] = useState(null);
  const [horarioEditTemp, setHorarioEditTemp] = useState({ hora_inicio: '', hora_fin: '' });
  const [nuevoHorario, setNuevoHorario] = useState({
    dia_semana: null,
    hora_inicio: '',
    hora_fin: '',
    activo: true
  });

  const diasSemana = [
    { valor: 1, label: 'Lunes' },
    { valor: 2, label: 'Martes' },
    { valor: 3, label: 'Miércoles' },
    { valor: 4, label: 'Jueves' },
    { valor: 5, label: 'Viernes' },
    { valor: 6, label: 'Sábado' },
    { valor: 7, label: 'Domingo' },
  ];

  const cargarHorarios = async () => {
    const token = getToken();
    try {
      const res = await api.get('/horarios', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const horariosData = res.data.horarios || [];
      setHorarios(horariosData);
      
      // Agrupar horarios por día
      const agrupados = horariosData.reduce((acc, horario) => {
        if (!acc[horario.dia_semana]) {
          acc[horario.dia_semana] = [];
        }
        acc[horario.dia_semana].push(horario);
        return acc;
      }, {});
      setHorariosPorDia(agrupados);
    } catch (err) {
      console.error('❌ Error al cargar horarios:', err);
      toast.error('Error al cargar los horarios');
    }
  };

  useEffect(() => {
    cargarHorarios();
  }, []);

  // Cambia solo el estado temporal de edición
  const handleEditTempChange = (e) => {
    const { name, value } = e.target;
    setHorarioEditTemp(prev => ({ ...prev, [name]: value }));
  };

  const guardarCambios = async (id, dia_semana, activo) => {
    const token = getToken();
    try {
      await api.put(`/horario/${id}`, 
        { dia_semana, hora_inicio: horarioEditTemp.hora_inicio, hora_fin: horarioEditTemp.hora_fin, activo },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Horario actualizado correctamente');
      setEditando(null);
      setHorarioEditTemp({ hora_inicio: '', hora_fin: '' });
      cargarHorarios();
    } catch (err) {
      console.error('❌ Error al actualizar horario:', err);
      toast.error('Error al actualizar horario');
    }
  };

  const eliminarHorario = async (id) => {
    const confirmar = window.confirm('¿Seguro que deseas eliminar este horario?');
    if (!confirmar) return;

    const token = getToken();
    try {
      await api.delete(`/horario/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Horario eliminado');
      cargarHorarios();
    } catch (err) {
      console.error('❌ Error al eliminar horario:', err);
      toast.error('Error al eliminar el horario');
    }
  };

  const crearHorario = async () => {
    const token = getToken();
    
    if (!nuevoHorario.hora_inicio || !nuevoHorario.hora_fin) {
      toast.warning('Completa todos los campos');
      return;
    }

    try {
      await api.post('/horario',
        {
          dia_semana: nuevoHorario.dia_semana,
          hora_inicio: nuevoHorario.hora_inicio,
          hora_fin: nuevoHorario.hora_fin,
          activo: nuevoHorario.activo
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Horario creado correctamente');
      setNuevoHorario({ dia_semana: 1, hora_inicio: '', hora_fin: '', activo: true });
      cargarHorarios();
    } catch (err) {
      console.error('❌ Error al crear horario:', err);
      toast.error('Error al crear el horario');
    }
  };

  const toggleActivo = async (horario) => {
    const token = getToken();
    try {
      await api.put(`/horario/${horario.id}`, 
        { 
          dia_semana: horario.dia_semana,
          hora_inicio: horario.hora_inicio,
          hora_fin: horario.hora_fin,
          activo: !horario.activo 
        },
        { headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(`Horario ${!horario.activo ? 'activado' : 'desactivado'}`);
      cargarHorarios();
    } catch (err) {
      console.error('❌ Error al cambiar estado:', err);
      toast.error('Error al cambiar el estado');
    }
  };

  return (
    <main className="site-width">
      <div className="texto-dashboard">
        <h1>Gestión de Horarios</h1>
        <p>Define tus horarios de trabajo semanales. Puedes configurar múltiples franjas horarias por día.</p>
      </div>

      {/* Vista de horarios por día */}
      <div className="horarios-semana">
        {diasSemana.map(dia => (
          <div key={dia.valor} className="dia-horario-card">
            <div className="dia-horario-header">
              <h3>{dia.label}</h3>
              <button 
                className="boton-añadir-horario"
                onClick={() => setNuevoHorario({ ...nuevoHorario, dia_semana: dia.valor })}
              >
                + Añadir franja
              </button>
            </div>
            
            <div className="franjas-horario">
              {horariosPorDia[dia.valor]?.length > 0 ? (
                horariosPorDia[dia.valor].map(horario => (
                  <div key={horario.id} className={`franja-horario ${!horario.activo ? 'inactivo' : ''}`}>
                    {editando === horario.id ? (
                      <div className="editar-franja">
                        <input
                          type="time"
                          name="hora_inicio"
                          value={horarioEditTemp.hora_inicio}
                          onChange={handleEditTempChange}
                          step="300"
                        />
                        <span>-</span>
                        <input
                          type="time"
                          name="hora_fin"
                          value={horarioEditTemp.hora_fin}
                          onChange={handleEditTempChange}
                          step="300"
                        />
                        <div className="acciones-franja">
                          <button
                            className="boton-confirmar"
                            onClick={() => guardarCambios(
                              horario.id,
                              horario.dia_semana,
                              horario.activo
                            )}
                          >
                            <img src="/images/confirmar.svg" alt="Guardar" />
                          </button>
                          <button
                            className="boton-cancelar"
                            onClick={() => {
                              setEditando(null);
                              setHorarioEditTemp({ hora_inicio: '', hora_fin: '' });
                              cargarHorarios();
                            }}
                          >
                            <img src="/images/cancelar.svg" alt="Cancelar" />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="ver-franja">
                        <span className="horario-texto">
                          {typeof horario.hora_inicio === 'string' ? horario.hora_inicio.slice(0,5) : ''} - {typeof horario.hora_fin === 'string' ? horario.hora_fin.slice(0,5) : ''}
                        </span>
                        <div className="acciones-franja">
                          <button
                            className="boton-toggle"
                            onClick={() => toggleActivo(horario)}
                            title={horario.activo ? 'Desactivar' : 'Activar'}
                          >
                            <img src={horario.activo ? "/images/ojo.svg" : "/images/ojo-cruzado.svg"} alt={horario.activo ? 'Activo' : 'Inactivo'} />
                          </button>
                          <button
                            className="boton-editar"
                            onClick={() => {
                              setEditando(horario.id);
                              setHorarioEditTemp({
                                hora_inicio: typeof horario.hora_inicio === 'string' ? horario.hora_inicio.slice(0,5) : '',
                                hora_fin: typeof horario.hora_fin === 'string' ? horario.hora_fin.slice(0,5) : ''
                              });
                            }}
                          >
                            <img src="/images/formulario.svg" alt="Editar" />
                          </button>
                          <button
                            className="boton-eliminar"
                            onClick={() => eliminarHorario(horario.id)}
                          >
                            <img src="/images/cancelar.svg" alt="Eliminar" />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p className="sin-horarios">Sin horarios configurados</p>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Modal/Form para crear nuevo horario */}
      {nuevoHorario.dia_semana && (
        <div className="modal-nuevo-horario">
          <div className="modal-contenido">
            <h3>Nuevo horario - {diasSemana.find(d => d.valor === nuevoHorario.dia_semana)?.label}</h3>
            <div className="form-nuevo-horario">
              <div className="campo-horario">
                <label>Hora inicio</label>
                <input
                  type="time"
                  value={nuevoHorario.hora_inicio}
                  onChange={(e) => setNuevoHorario({ ...nuevoHorario, hora_inicio: e.target.value })}
                />
              </div>
              <div className="campo-horario">
                <label>Hora fin</label>
                <input
                  type="time"
                  value={nuevoHorario.hora_fin}
                  onChange={(e) => setNuevoHorario({ ...nuevoHorario, hora_fin: e.target.value })}
                />
              </div>
            </div>
            <div className="acciones-modal">
              <button className="boton-crear" onClick={crearHorario}>
                Crear horario
              </button>
              <button 
                className="boton-cancelar-modal" 
                onClick={() => setNuevoHorario({ dia_semana: null, hora_inicio: '', hora_fin: '', activo: true })}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="bottom-right" autoClose={3000} />
    </main>
  );
};

export default HorariosAdmin;
